import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72cc8d1e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-in-line gap--9" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = ["alt", "src"]
const _hoisted_4 = {
  key: 0,
  class: "icon-count"
}

import { computed, onMounted, onUnmounted, ref, Ref, watch } from 'vue';
import { useChatStore } from '@/store/modules/chat';
import { useUserStore } from '@/store/modules/user';
import { RouteLocationRaw, useRouter } from 'vue-router';
import { checkUserLoginHandler } from '@/utils/Common/Common';

type IconType = {
  id: string;
  icon: string;
  activeIcon: string;
  href?: RouteLocationRaw;
  clickHandler?: () => void;
  count?: number;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsBlock',
  setup(__props) {

let timer: Ref<number | undefined> = ref(undefined);
const startTimer = () => {
  timer.value = setInterval(() => {
    useChatStore().getCountChannelWithNew();
    useUserStore().getCountNotifications();
  }, 30000);
};
const stopTimer = () => {
  clearInterval(timer.value);
};

const icons = computed((): IconType[] => {
  return [
    {
      id: 'search',
      icon: require('@/assets/img/header/icons/icon-search.png'),
      activeIcon: require('@/assets/img/header/icons/icon-search-active.png'),
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile', params: { id: 'searchHistory' } });
        }),
    },
    {
      id: 'compare',
      icon: require('@/assets/img/header/icons/icon-menu.png'),
      activeIcon: require('@/assets/img/header/icons/icon-menu-active.png'),
      href: { name: 'compare' },
      count: useUserStore().user?.comparisons,
    },
    {
      id: 'like',
      icon: require('@/assets/img/header/icons/icon-like.png'),
      activeIcon: require('@/assets/img/header/icons/icon-like-active.png'),
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile', params: { id: 'favorite' } });
        }),
      count: useUserStore().user?.favorite_ids.length,
    },
    {
      id: 'message',
      icon: require('@/assets/img/header/icons/icon-message.png'),
      activeIcon: require('@/assets/img/header/icons/icon-message-active.png'),
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile', params: { id: 'chat' } });
        }),
      count: useChatStore().chatIdsWithNewMessage.length,
    },
    {
      id: 'bell',
      icon: require('@/assets/img/header/icons/icon-bell.png'),
      activeIcon: require('@/assets/img/header/icons/icon-bell-active.png'),
      clickHandler: () =>
        checkUserLoginHandler().then(() => {
          router.push({ name: 'profile', params: { id: 'notifications' } });
        }),
      count: useUserStore().user?.notificationUser.open,
    },
  ];
});
const router = useRouter();

onMounted(async () => {
  if (useUserStore().getIsLogin()) {
    await useChatStore().getCountChannelWithNew();
    await useUserStore().getCountNotifications();
    startTimer();
  }
});

onUnmounted(() => {
  stopTimer();
});
watch(
  () => useUserStore().getIsLogin(),
  async () => {
    if (useUserStore().getIsLogin()) {
      await useChatStore().getCountChannelWithNew();
      await useUserStore().getCountNotifications();
      startTimer();
    } else {
      stopTimer();
    }
  },
);

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(icons.value, (icon) => {
      return (_openBlock(), _createElementBlock("div", {
        key: icon.id,
        class: "relative"
      }, [
        _createVNode(_component_base_button, {
          href: icon.href,
          icon: "",
          "style-type": "border",
          onClick: icon.clickHandler
        }, {
          icon: _withCtx(() => [
            _createElementVNode("img", {
              alt: icon.id,
              class: _normalizeClass({ 'icon-bell': icon.id === 'bell' && icon.count }),
              src: icon.icon
            }, null, 10, _hoisted_2)
          ]),
          iconActive: _withCtx(() => [
            _createElementVNode("img", {
              alt: icon.id,
              src: icon.activeIcon
            }, null, 8, _hoisted_3)
          ]),
          _: 2
        }, 1032, ["href", "onClick"]),
        (icon.count)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(icon.count), 1))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}
}

})